import generateAsyncRouteComponent from '../generateAsyncRouteComponent';

export default {
  path: 'bag',
  component: generateAsyncRouteComponent({
    loader: () => import('./containers/BagPageContainer'),
  }),
};
